import { render } from "./NcrmPrivacyBulkProgress.vue?vue&type=template&id=5d542a7b&scoped=true"
import script from "./NcrmPrivacyBulkProgress.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyBulkProgress.vue?vue&type=script&lang=js"

import "./NcrmPrivacyBulkProgress.vue?vue&type=style&index=0&id=5d542a7b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d542a7b"]])

export default __exports__